export { HamburgerIcon } from './HamburgerIcon';
export { default } from './HamburgerIcon';